var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextpageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.23L7.80459 22L18 12L7.80459 2L6 3.77L14.3908 12L6 20.23Z",
    fill: "#206BB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextpageicon);
export default __webpack_public_path__ + "static/media/nextpageicon.7766cdb3a7430891acd22ae8a86177ad.svg";
export { ForwardRef as ReactComponent };